<template>
    <div class="menu" :class="{close:menuClose}">
        <div class="logo-div"><img @click="linkTo(0)" src="~assets/image/back-logo.png"></div>

		<!-- 主菜单 -->
        <div class="menu-choose" :class="{active:menuActive(index) }" v-for="(item,index) in mainChoice" :key="item.name" :text="item.text" @click="linkTo(index+1)">
            <div class="choose-icon">
                <img :src="item.icon | menuIcon(menuActive(index))">
            </div>
            <div class="text">{{ item.text }}</div>
        </div>

		<!-- 底部展开按钮 -->
        <div class="func" @click="menuClose = !menuClose"><img src="~assets/image/back-morebtn.png"></div>

		<!-- 二级菜单 -->
        <div class="side-menu" :class="{show:$route.name != 'backhome'}">
            <div class="side-list" v-for="(item,index) in mainChoice" :key="item.name" :class="{show:menuActive(index)}">
                <div class="list-item" v-for="(sec_item,i) in secondMenu(item)" :key="sec_item.name" :class="{active:activeArr[index] == i}" @click="linkTo(index+1,i)">
					{{ sec_item.text }}
				</div>
            </div>
        </div>
    </div>
</template>	

<script>
	import backRouter from "src/config/router-back-config.js"
	import { mapGetters } from "vuex"
	export default {
		data(){
			return {
				menuClose:true,  //菜单状态控制
				activeIndex:0,   //菜单tab
			}
		},
		computed:{
			...mapGetters(['codeList']), 
			mainChoice(){  //路由文件  主菜单
				return backRouter.children.filter(item=>{
					item.meta = item.meta || {};
					return item.meta.code == undefined || this.codeList.some(code=> code == item.meta.code); 
				})
			},  
			activeArr(){  //二级菜单tab数组
				return this.mainChoice.map(item=>{
					return 0;
				});
			},
		},
		watch:{
			"$route"(to,from){
				this.menuChange(to);
			}
		},
		created(){ 
			this.menuChange(this.$route);
		},
		methods:{
			menuActive(index){
				return this.activeIndex == index+1;
			},
			linkTo(index,secIndex){  //菜单路由
				this.activeIndex = index;
				if(index == 0){
					this.$router.push({ name: 'backhome'});
					return ;
				}
				this.secLinkTo(index-1,secIndex);
				this.menuClose = true;
			},
			secLinkTo(oneIndex,secIndex){  //oneindex为主菜单index
				if(secIndex!=undefined){
					this.activeArr[oneIndex] = secIndex;
				}
				secIndex = secIndex || this.activeArr[oneIndex];
				let secList = this.secondMenu(this.mainChoice[oneIndex]);
				let secName = secList?secList[secIndex].name:"backhome";
				this.$router.push({ name: secName});
			},
			secondMenu(item){  //构造2级菜单
				let list = item.children || [];
				return list.filter(choice=>{
					choice.meta = choice.meta || {};
					let arr = [
						choice.meta.code == undefined,
						this.codeList.some(code=>code == choice.meta.code),
					]
					return  choice.secondMenu == true && arr.some(val=>val);
				});
			},
			menuChange(route){  //根据路由，安排菜单选项active状态
				let pathArr = route.fullPath.substring(1).split("/").map(str=>str.split('?')[0]);
				this.mainChoice.some((one,index)=>{
					if(one.path == pathArr[1]){

						this.activeIndex = index + 1;
						this.secondMenu(one).some((sec,i)=>{
							if(sec.path == pathArr[2]){
								this.activeArr[index] = i;
								return true;
							}
						});
						return true;
					}
				});
			}

		},
	}
</script>


// WEBPACK FOOTER //
// backMenu.vue?417a1fb2